<span [ngClass]="styles.text" [innerHTML]="textVal">
</span>

<ng-container *ngFor="let action of actions">
	<button type="button" [ngClass]="action.buttonClass" (click)="onClick(action)" [attr.aria-label]="action.title">
		<span [ngClass]="action.iconClass"></span>
	</button>
	<span *ngIf="action.helperIconClass" [ngClass]="action.helperIconClass">{{ action.helperIconText }}</span>
</ng-container>
